import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const faqs = [
  {
    q: "İzmir'e gitmek için en iyi zaman hangisi?",
    a: "İzmir'i ziyaret etmek için en ideal dönemler Nisan–Haziran ve Eylül–Kasım aylarıdır. Bu dönemlerde hava ılıman, deniz yüzme için uygun ve kalabalık görece azdır. Temmuz–Ağustos çok sıcak olabilir (35–40°C); ancak deniz tatili için tercih edilebilir. Kış aylarında İzmir ılıman kalır ve Efes, Şirince gibi tarihi mekanlar daha sakin ziyaret edilebilir.",
  },
  {
    q: "İzmir'de mutlaka görülmesi gereken yerler hangileri?",
    a: "Kordon sahil şeridi, Kemeraltı Çarşısı, Konak Meydanı ve Saat Kulesi, Kadifekale, Agora Antik Kenti, Efes Antik Kenti (Selçuk), Şirince köyü, Alaçatı, Çeşme ve Seferihisar İzmir'in mutlaka görülmesi gereken yerleri arasındadır. Asansör ve çevresindeki tarihi Yahudi mahallesi de ayrı bir keşif sunar.",
  },
  {
    q: "İzmir'de ne yenilmeli?",
    a: "İzmir'de mutlaka tatmanız gereken lezzetler: boyoz (sabah kahvaltısı için geleneksel hamur işi), İzmir köfte, kumru (Kordon'da meşhur sandviç), gevrek (İzmir simidi), zeytinyağlı mezeler, taze deniz ürünleri ve Alaçatı'nın Ege kahvaltısı. Kemeraltı Çarşısı'ndaki tarihi lokantalar ve Kordon'daki balık restoranları en popüler yeme-içme noktalarıdır.",
  },
  {
    q: "İzmir'e nasıl gidilir?",
    a: "İzmir Adnan Menderes Havalimanı, İstanbul, Ankara ve diğer büyük şehirlerden direkt uçuşlarla bağlantılıdır. İstanbul'dan uçuş süresi yaklaşık 1 saat, otobüsle ise 8–9 saattir. Şehir içinde metro, tramvay, vapur ve İZBAN (banliyö treni) kullanılabilir. İZBAN ile Selçuk (Efes) ve Aliağa'ya kolayca ulaşılabilir.",
  },
  {
    q: "İzmir'de kaç gün geçirmek gerekir?",
    a: "İzmir şehir merkezini (Kordon, Kemeraltı, Konak) görmek için 2 gün yeterlidir. Efes, Şirince ve Alaçatı'yı eklerseniz 4–5 gün idealdir. Çeşme Yarımadası, Foça, Bergama ve Seferihisar gibi çevre destinasyonları da ekleyerek 7–10 günlük kapsamlı bir Ege turu yapabilirsiniz.",
  },
  {
    q: "İzmir'den günübirlik gezi yapılabilecek yerler var mı?",
    a: "İzmir'den günübirlik yapılabilecek en popüler destinasyonlar: Efes Antik Kenti ve Şirince (1 saat), Alaçatı ve Çeşme (1 saat), Bergama ve Asklepion (1,5 saat), Foça (1 saat), Seferihisar ve Sığacık (45 dakika), Pamukkale (2,5 saat) ve Bodrum (2,5 saat)'dur.",
  },
  {
    q: "Alaçatı ve Çeşme arasındaki fark nedir?",
    a: "Alaçatı, taş döşeli sokakları, bougainvillea çiçekleriyle süslü Rum evleri ve dünya standartlarında rüzgar sörfü koşullarıyla daha butik ve kozmopolit bir atmosfer sunar. Çeşme ise daha geniş plajları, marina ve gece hayatıyla daha kalabalık ve hareketli bir tatil kenti kimliği taşır. İkisi birbirine 10 dakika mesafededir.",
  },
  {
    q: "İzmir'de Kemeraltı Çarşısı nasıl bir yer?",
    a: "Kemeraltı, İzmir'in tarihi kapalı çarşısı olup yüzlerce yıllık geçmişiyle şehrin en özgün alışveriş ve kültür deneyimini sunar. Baharatlar, zeytinyağı, el sanatları, antika eşyalar ve geleneksel giyim ürünleri bulunabilir. Çarşı içindeki tarihi hanlar, camiler ve kiliseler de ayrı bir keşif sunar. Sabah erken saatlerde ziyaret etmek daha keyiflidir.",
  },
  {
    q: "İzmir'de deniz ve plaj seçenekleri nelerdir?",
    a: "İzmir çevresindeki en güzel plajlar: Ilıca Plajı (Çeşme, termal suları ile ünlü), Altınkum Plajı (Didim), Kalem Adası (Seferihisar), Foça plajları, Mordoğan ve Ildırı koyları. Alaçatı'nın rüzgar sörfü plajı ise dünya genelinde tanınan bir spor destinasyonudur.",
  },
  {
    q: "İzmir'de Efes'e nasıl gidilir?",
    a: "Efes Antik Kenti'ne İzmir'den İZBAN ile Selçuk istasyonuna gidip oradan dolmuş veya taksi ile ulaşabilirsiniz (toplam yaklaşık 1,5 saat). Özel araçla ise yaklaşık 1 saat sürer. Efes'i ziyaret ederken Selçuk'taki Efes Müzesi'ni ve Meryem Ana Evi'ni de programınıza eklemenizi öneririz.",
  },
  {
    q: "İzmir'de nerede konaklayabilirim?",
    a: "Kordon ve Alsancak, şehrin en canlı ve merkezi semtleri olup konaklama için idealdir. Konak, tarihi çarşıya yakınlığıyla pratik bir seçenektir. Alaçatı ve Çeşme'de butik oteller ve tatil köyleri mevcuttur. Selçuk, Efes ziyareti için ideal bir üs noktasıdır. Bütçenize göre hostellerden lüks otellere kadar geniş bir yelpaze bulunmaktadır.",
  },
  {
    q: "İzmir'de Bergama nasıl ziyaret edilir?",
    a: "Bergama (antik Pergamon), İzmir'e 100 km uzaklıkta olup otobüs veya özel araçla yaklaşık 1,5 saatte ulaşılabilir. Akropol, Asklepion (antik tıp merkezi) ve Kızıl Avlu başlıca ziyaret noktalarıdır. Akropol'e teleferikle çıkmak hem pratik hem de manzara açısından tavsiye edilir. Bergama'nın yerel pazarı ve geleneksel halıları da ilgi çekicidir.",
  },
];

const IzmirFaq = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const title = "İzmir Seyahat SSS — Efes, Alaçatı ve Ege Rehberi 2026";
    const desc = "İzmir'e seyahat planlayanlar için en sık sorulan sorular: Efes, Alaçatı, Çeşme, Kemeraltı, ulaşım ve konaklama hakkında kapsamlı Ege rehberi.";
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setCanonical = (url: string) => {
      let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
      el.setAttribute("href", url);
    };
    const injectSchema = (id: string, data: object) => {
      let el = document.getElementById(id);
      if (!el) { el = document.createElement("script"); el.id = id; el.setAttribute("type", "application/ld+json"); document.head.appendChild(el); }
      el.textContent = JSON.stringify(data);
    };

    setCanonical("https://geziturkiyem.com/izmir-sss");
    setMeta("description", desc);
    setMeta("keywords", "izmir seyahat, izmir gezilecek yerler, efes antik kenti, alacati, cesme, izmir sss, izmir rehberi, izmir kordon, izmir kemeralti, izmir konak, izmir saat kulesi, izmir kadifekale, izmir agora, sirince koyu, kusadasi, foca, bergama, seferihisar, sigacik, izmir ne zaman gidilir, izmir konaklama, izmir ulasim, izmir gunubirlik gezi, izmir alisveris, izmir boyoz, izmir kofte, izmir kumru, izmir gevrek, ege kahvaltisi, izmir plajlar, ilica plaji, alacati ruzgar sorfü, izmir alsancak, izmir buca, izmir karsiyaka, izmir bornova, izmir bergama asklepion, izmir didim, izmir milet, izmir priene, ege seyahat rehberi");
    setMeta("og:title", title, true);
    setMeta("og:description", desc, true);
    setMeta("og:type", "article", true);
    setMeta("og:url", "https://geziturkiyem.com/izmir-sss", true);
    setMeta("og:image", "https://readdy.ai/api/search-image?query=Izmir%20clock%20tower%20Konak%20square%20Alacati%20stone%20houses%20Aegean%20sea%20Turkey%20city%20panoramic&width=1200&height=630&seq=izm-sss-og&orientation=landscape", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", desc);

    injectSchema("schema-izmir-faq", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((f) => ({
        "@type": "Question",
        "name": f.q,
        "acceptedAnswer": { "@type": "Answer", "text": f.a },
      })),
    });

    injectSchema("schema-izmir-breadcrumb", {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://geziturkiyem.com/" },
        { "@type": "ListItem", "position": 2, "name": "İzmir SSS", "item": "https://geziturkiyem.com/izmir-sss" },
      ],
    });

    return () => {
      document.title = "Türkiye Seyahat Rehberi";
      ["schema-izmir-faq", "schema-izmir-breadcrumb"].forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="relative pt-20 pb-16 overflow-hidden bg-stone-900">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Izmir%20Turkey%20Kordon%20promenade%20seafront%20Aegean%20sea%20sunset%20golden%20hour%20city%20skyline%20beautiful%20panoramic%20view&width=1400&height=500&seq=izm-sss-hero&orientation=landscape"
            alt="İzmir"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
        </div>
        <div className="relative max-w-3xl mx-auto px-4 md:px-8 text-center">
          <nav className="flex items-center justify-center gap-2 text-xs text-stone-400 mb-5">
            <Link to="/" className="hover:text-white transition-colors">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">İzmir SSS</span>
          </nav>
          <span className="inline-block bg-amber-500/20 border border-amber-400/30 text-amber-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-widest">
            Sık Sorulan Sorular
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            İzmir Seyahat Rehberi
          </h1>
          <p className="text-stone-300 text-sm max-w-xl mx-auto">
            İzmir'e seyahat planlayanların en çok merak ettiği sorular ve kapsamlı Ege rehberi.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-14">
        <div className="bg-amber-50 border border-amber-100 rounded-2xl p-6 mb-10">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
              <i className="ri-ship-line text-amber-600 text-xl"></i>
            </div>
            <div>
              <h2 className="font-bold text-stone-900 mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                İzmir Hakkında
              </h2>
              <p className="text-stone-600 text-sm leading-relaxed">
                Türkiye'nin üçüncü büyük şehri İzmir; Ege'nin berrak suları, Efes gibi dünya mirası antik kentleri, Alaçatı'nın taş sokakları ve Kordon'un canlı sahil yaşamıyla her yıl milyonlarca ziyaretçiyi ağırlamaktadır. Aşağıda İzmir seyahati hakkında en sık sorulan soruları bulabilirsiniz.
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`border rounded-2xl overflow-hidden transition-all duration-200 ${
                openIndex === i ? "border-amber-300 bg-amber-50/50" : "border-stone-100 bg-white hover:border-stone-200"
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
              >
                <h4 className={`font-semibold text-sm leading-snug pr-4 ${openIndex === i ? "text-amber-800" : "text-stone-900"}`}>
                  <a id={`sss-${i + 1}`} className="scroll-mt-20">{faq.q}</a>
                </h4>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                  openIndex === i ? "bg-amber-500 text-white rotate-180" : "bg-stone-100 text-stone-500"
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-stone-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <Link to="/istanbul-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-building-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">İstanbul SSS</p>
            <p className="text-xs text-stone-400">Boğaz ve tarihi yarımada rehberi</p>
          </Link>
          <Link to="/antalya-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-sun-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Antalya SSS</p>
            <p className="text-xs text-stone-400">Akdeniz tatili için rehber</p>
          </Link>
          <Link to="/places" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-map-2-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Tüm Mekanlar</p>
            <p className="text-xs text-stone-400">Türkiye'nin tüm destinasyonları</p>
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default IzmirFaq;
